// @flow
import React from "react";
import { withGlobalContext } from "../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";

const Disclaimer = ({ classes, compliance }) => (
  <div className={classes.root}>
    {compliance && compliance.listingDisclaimerPage ? (
      <div
        dangerouslySetInnerHTML={{ __html: compliance.listingDisclaimerPage }}
        className="ref__listing-disclaimer-page"
      />
    ) : null}
  </div>
);

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxWidth: "800px",
    minHeight: "70vh",
    padding: "32px 14px",
    margin: "0 auto",
    "& p": {
      fontSize: "18px",
      lineHeight: "1.5em",
      paddingBottom: theme.spacing.unit * 1.5,
    },
  },
});

export default withGlobalContext(withStyles(styles)(Disclaimer));
